import {
  WithStyles,
  Theme,
  createStyles,
  withStyles,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  IconButton,
  Badge,
  Toolbar,
  InputBase,
  TextField,
  MenuItem,
  Button,
  Checkbox,
  Typography,
  Tooltip,
  Avatar,
  alpha,
} from "@material-ui/core";
import clsx from "clsx";
import * as React from "react";
import SwapHorizIcon from "@material-ui/icons/SwapHoriz";
import PeopleIcon from "@material-ui/icons/People";
import LicenseIcon from "@material-ui/icons/Payment";
import AuthorisedIcon from "@material-ui/icons/EmojiTransportation";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import SearchIcon from "@material-ui/icons/Search";
import AssignmentTurnedInIcon from "@material-ui/icons/AssignmentTurnedIn";
import { grey } from "@material-ui/core/colors";
import PDFTableComponents from "../print/PDFTableComponents";
import { PDFDownloadLink } from "@react-pdf/renderer";
import PrintIcon from "@material-ui/icons/Print";
import HasPermission from "../auth/HasPermission";
import { AuthConsumer } from "../routes/AuthContext";
import DeleteIcon from "@material-ui/icons/Delete";
import GenericDialog from "../dialogs/GenericDialog";
import { types } from "../dialogs/AddCompanyDialog";
const styles = (theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
    },
    container: {
      maxHeight: 440,
    },
    margin: {
      margin: theme.spacing(1),
    },
    button: {
      margin: theme.spacing(1),
    },
    visuallyHidden: {
      border: 0,
      clip: "rect(0 0 0 0)",
      height: 1,
      margin: -1,
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      top: 20,
      width: 1,
    },
    searchIcon: {
      padding: theme.spacing(0, 2),
      height: "100%",
      position: "absolute",
      pointerEvents: "none",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    inputRoot: {
      color: "inherit",
    },
    extendedIcon: {
      marginRight: 1,
    },
    title: {
      flex: "1 1 100%",
    },
    small: {
      width: theme.spacing(3),
      height: theme.spacing(3),
    },
    large: {
      width: theme.spacing(7),
      height: theme.spacing(7),
    },
    search: {
      height: 48,
      position: "relative",
      alignItems: "center",
      display: "flex",
      borderRadius: theme.shape.borderRadius,
      borderColor: "grey",
      border: 2,
      backgroundColor: alpha(grey[500], 0.15),
      "&:hover": {
        backgroundColor: alpha(grey[500], 0.25),
      },
      marginLeft: 0,
      width: "100%",
      [theme.breakpoints.up("sm")]: {
        marginLeft: theme.spacing(1),
        width: "auto",
      },
    },
    inputInput: {
      height: 48,
      padding: theme.spacing(1, 1, 1, 0),
      // vertical padding + font size from searchIcon
      paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
      transition: theme.transitions.create("width"),
      width: "100%",
      [theme.breakpoints.up("sm")]: {
        width: "20ch",
        "&:focus": {
          width: "20ch",
        },
      },
    },
  });

function descendingComparator(a: any, b: any, orderBy: any) {
  if (b && b.inspection && a && a.inspection) {
    if (b.inspection[orderBy]) {
      if (b.inspection[orderBy] < a.inspection[orderBy]) {
        return -1;
      }
      if (b.inspection[orderBy] > a.inspection[orderBy]) {
        return 1;
      }
    } else {
      if (orderBy === "completedBy") {
        if (b.assign.assignedTo["fullName"] < a.assign.assignedTo["fullName"]) {
          return -1;
        }
        if (b.assign.assignedTo["fullName"] > a.assign.assignedTo["fullName"]) {
          return 1;
        }
      } else if (orderBy === "completedOn") {
        if (b.assign["completionDate"] < a.assign["completionDate"]) {
          return -1;
        }
        if (b.assign["completionDate"] > a.assign["completionDate"]) {
          return 1;
        }
      }
    }
  } else if (b && a) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
  }
  return 0;
}

type Order = "asc" | "desc";

function getComparator<Key extends keyof any>(
  order: Order,
  orderBy: Key
): (
  a: { [key in Key]: number | string },
  b: { [key in Key]: number | string }
) => number {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort<T>(array: T[], comparator: (a: T, b: T) => number) {
  const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

interface Props extends WithStyles<typeof styles> {
  tableName: any;
  columns: any;
  data: any;
  createData: any;
  company: any;
  uniqueIdentifier: any;
  deleteAllSelected: any;
  deleteAllAction?: any;
  actions?: any;
  showDialog?: any;
}
class TableComponent extends React.Component<Props> {
  state = {
    page: 0,
    rowsPerPage: 10,
    order: "asc" as Order,
    orderBy: "asc",
    searchQuery: "",
    columnSearchQuery: "",
    numSelected: 0,
    isItemSelected: false,
    selected: Array<any>(),
    showConfirmationDialog: false,
  };
  handleChangePage = (event: any, newPage: any) => {
    this.setState({ page: newPage });
  };
  handleChangeRowsPerPage = (event: any) => {
    this.setState(() => ({
      rowsPerPage: event.target.value,
      page: 0,
    }));
  };

  getObjectFromKey = (obj: any, keyVar: any) => {
    let objValue = null;
    Object.entries(obj).map(([key, value]) => {
      if (key === keyVar) {
        objValue = value; //Object.fromEntries(Object.entries(obj));
      }
      return null;
    });
    return objValue;
  };
  componentDidMount = () => {};
  renderValue = (value: any, row: any) => {
    const { classes } = this.props;
    if (value && value.title === "License Datails") {
      return (
        <IconButton
          aria-label="delete"
          className={classes.margin}
          onClick={() => value.action(row)}
        >
          <Badge
            badgeContent={row.licenseDetails ? row.licenseDetails.length : ""}
          >
            <LicenseIcon />
          </Badge>
        </IconButton>
      );
    } else if (value && value.title === "Authorised Equipments") {
      return (
        <IconButton
          aria-label="delete"
          className={classes.margin}
          onClick={() => value.action(row)}
        >
          <Badge
            badgeContent={row.licenseDetails ? row.licenseDetails.length : ""}
          >
            <AuthorisedIcon />
          </Badge>
        </IconButton>
      );
    } else if (value && value.title === "Actioned Inspections") {
      if (row.actionedCount && Number(row.actionedCount) > 0) {
        return (
          <IconButton
            aria-label="delete"
            className={classes.margin}
            onClick={() => value.action(row)}
          >
            <Badge
              badgeContent={row.actionedCount ? row.actionedCount : ""}
              color="secondary"
            >
              <AssignmentTurnedInIcon />
            </Badge>
          </IconButton>
        );
      } else {
        return null;
      }
    } else {
      return value;
    }
  };
  handleRequestSort = (event: React.MouseEvent<unknown>, property: any) => {
    const isAsc = this.state.orderBy === property && this.state.order === "asc";
    this.setState({ order: isAsc ? "desc" : "asc" });
    this.setState({ orderBy: property });
  };

  EnhancedTableToolbar = (user: any, accessRules: any) => {
    const { classes, columns, data, createData } = this.props;
    const seachableColumns = columns.filter((c: any) => {
      return c.isSeachable;
    });
    if (seachableColumns.length === 0) {
      return;
    }
    return (
      <Toolbar
        className={clsx(classes.root)}
        style={{ justifyContent: "flex-end", display: "flex" }}
      >
        {this.state.numSelected > 0 ? (
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography
              className={classes.title}
              color="secondary"
              variant="subtitle1"
              component="div"
            >
              {this.state.numSelected} selected
            </Typography>
            <Tooltip title="Delete">
              <IconButton
                aria-label="delete"
                onClick={() => {
                  this.setState({
                    showConfirmationDialog: true,
                  });
                }}
              >
                <DeleteIcon color={"secondary"} />
              </IconButton>
            </Tooltip>
          </div>
        ) : (
          <div
            style={{
              width: "50%",
              display: "flex",
              alignItems: "center",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{
                flex: 0.5,
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "flex-end",
              }}
            >
              <HasPermission
                role={user.role}
                accessRules={accessRules}
                perform="dashboard:print2"
                yes={() => (
                  <PDFDownloadLink
                    document={
                      <PDFTableComponents
                        columns={columns}
                        createData={createData}
                        data={stableSort(
                          data,
                          getComparator(this.state.order, this.state.orderBy)
                        )}
                        company={this.props.company}
                      />
                    }
                    style={{
                      color: "black",
                      textDecoration: "none",
                    }}
                    fileName={
                      columns && columns.length > 0
                        ? columns[0].tableName
                        : "Dahboard.pdf"
                    }
                  >
                    {({ blob, url, loading, error }) =>
                      loading ? (
                        <Button type="submit" disabled={true} color="inherit">
                          <PrintIcon
                            style={{ margin: 10 }}
                            className={classes.extendedIcon}
                          />
                          Print
                        </Button>
                      ) : (
                        <Button type="submit" color="inherit">
                          <PrintIcon
                            style={{ margin: 10 }}
                            className={classes.extendedIcon}
                          />
                          Print
                        </Button>
                      )
                    }
                  </PDFDownloadLink>
                )}
                no={() => {
                  return null;
                }}
              ></HasPermission>
            </div>
            <div className={classes.search}>
              <div className={classes.searchIcon}>
                <SearchIcon />
              </div>
              <InputBase
                placeholder="Search…"
                onChange={(event) =>
                  this.setState({ searchQuery: event.target.value })
                }
                classes={{
                  root: classes.inputRoot,
                  input: classes.inputInput,
                }}
                inputProps={{ "aria-label": "search" }}
              />
            </div>
            <div
              style={{
                marginLeft: 20,
                width: "40%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <TextField
                select
                label={"Search by"}
                margin="dense"
                variant={"outlined"}
                value={
                  this.state.columnSearchQuery
                    ? this.state.columnSearchQuery
                    : seachableColumns[0].id
                }
                onChange={(event: any) => {
                  this.setState({ columnSearchQuery: event.target.value });
                }}
                fullWidth
              >
                {seachableColumns.map((option: any) => (
                  <MenuItem key={option.id} value={option.id}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            </div>
          </div>
        )}
      </Toolbar>
    );
  };
  isSelected = (name: string) => this.state.selected.indexOf(name) !== -1;
  handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { data, uniqueIdentifier } = this.props;
    if (event.target.checked) {
      const newSelecteds = data.map((row: any, index: any) =>
        uniqueIdentifier(row, index)
      );
      this.setState({
        selected: newSelecteds,
        numSelected: newSelecteds.length,
      });
      return;
    }
    this.setState({
      selected: new Array<any>(),
      numSelected: 0,
    });
  };

  handleCheckBoxChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    name: any
  ) => {
    const selectedIndex = this.state.selected.indexOf(name);
    let newSelected: string[] = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(this.state.selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(this.state.selected.slice(1));
    } else if (selectedIndex === this.state.selected.length - 1) {
      newSelected = newSelected.concat(this.state.selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        this.state.selected.slice(0, selectedIndex),
        this.state.selected.slice(selectedIndex + 1)
      );
    }
    this.setState({
      selected: newSelected,
      numSelected: newSelected.length,
    });
  };

  renderDeleteConfirmationDialog = () => {
    const { deleteAllSelected, tableName } = this.props;
    return (
      <GenericDialog
        type={types.DIALOG_INFO}
        title={`Deleting (${this.state.selected.length}) item${
          this.state.selected.length > 1 ? "(s)" : ""
        } from ${tableName}`}
        message={"Are you sure you want to proceed with this action?"}
        leftButtonName={"Cancel"}
        rightButtonName={"YES"}
        open={this.state.showConfirmationDialog}
        onCancel={() =>
          this.setState({
            showConfirmationDialog: false,
          })
        }
        onOk={() => {
          deleteAllSelected(this.state.selected);
          this.setState(
            {
              showConfirmationDialog: false,
            },
            () => {
              this.setState({
                selected: new Array<any>(),
                numSelected: 0,
              });
            }
          );
        }}
        handleClose={() =>
          this.setState({
            showConfirmationDialog: false,
          })
        }
      />
    );
  };

  isLoggedInUser = (user: any) => {
    const { data } = this.props;
    let results = data.filter((row: any) => {
      return row._id === user._id;
    });
    return results.length > 0 ? true : false;
  };

  render() {
    const {
      classes,
      columns,
      data,
      createData,
      showDialog,
      actions,
      uniqueIdentifier,
      deleteAllAction,
    } = this.props;
    const createSortHandler =
      (property: any) => (event: React.MouseEvent<unknown>) => {
        this.handleRequestSort(event, property);
      };

    const seachableColumns = columns.filter((c: any) => {
      return c.isSeachable;
    });
    const rowCount = data.length;
    return (
      <AuthConsumer>
        {({ authenticated, user, accessRules }) => {
          return (
            <React.Fragment>
              {this.renderDeleteConfirmationDialog()}
              <Paper className={classes.root}>
                {this.EnhancedTableToolbar(user, accessRules)}
                <TableContainer className={classes.container}>
                  <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                      <TableRow>
                        <HasPermission
                          role={user.role}
                          accessRules={accessRules}
                          perform={deleteAllAction ? deleteAllAction : ""}
                          yes={() => (
                            <TableCell padding="checkbox">
                              <Checkbox
                                indeterminate={
                                  this.state.numSelected > 0 &&
                                  this.state.numSelected < rowCount
                                }
                                checked={
                                  rowCount > 0 &&
                                  this.state.numSelected === rowCount
                                }
                                onChange={this.handleSelectAllClick}
                                inputProps={{
                                  "aria-label": "select all desserts",
                                }}
                              />
                            </TableCell>
                          )}
                        />
                        {columns.map((column: any) => {
                          return (
                            <TableCell
                              key={column.id}
                              sortDirection={
                                this.state.orderBy === column.id
                                  ? this.state.order
                                  : false
                              }
                              align={
                                column.id === "assign" ||
                                column.id === "signedBy" ||
                                column.id === "actions"
                                  ? "center"
                                  : "left"
                              }
                              style={{
                                minWidth: column.minWidth,
                                borderRight: 2,
                                borderColor: "orange",
                              }}
                            >
                              <TableSortLabel
                                active={this.state.orderBy === column.id}
                                direction={
                                  this.state.orderBy === column.id
                                    ? this.state.order
                                    : "asc"
                                }
                                onClick={createSortHandler(column.id)}
                              >
                                {column.label}
                                {this.state.orderBy === column.id ? (
                                  <span className={classes.visuallyHidden}>
                                    {this.state.order === "desc"
                                      ? "sorted descending"
                                      : "sorted ascending"}
                                  </span>
                                ) : null}
                              </TableSortLabel>
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {stableSort(
                        this.state.searchQuery
                          ? data.filter((x: any) => {
                              let column = this.state.columnSearchQuery
                                ? this.state.columnSearchQuery
                                : seachableColumns.length > 0
                                ? seachableColumns[0].id
                                : columns[0].id;
                              if (x.inspection || x.contacts) {
                                return (
                                  x.inspection &&
                                  JSON.stringify(x.inspection)
                                    .toLowerCase()
                                    .indexOf(
                                      this.state.searchQuery.toLowerCase()
                                    ) > 0
                                );
                              } else {
                                if (
                                  x[column] instanceof Object ||
                                  x[column] instanceof Array
                                ) {
                                  return (
                                    JSON.stringify(x)
                                      .toLowerCase()
                                      .indexOf(
                                        this.state.searchQuery.toLowerCase()
                                      ) > 0
                                  );
                                } else {
                                  return x[column]
                                    .toLowerCase()
                                    .includes(
                                      this.state.searchQuery.toLowerCase()
                                    );
                                }
                              }
                            })
                          : data,
                        getComparator(this.state.order, this.state.orderBy)
                      )
                        .slice(
                          this.state.page * this.state.rowsPerPage,
                          this.state.page * this.state.rowsPerPage +
                            this.state.rowsPerPage
                        )
                        .map((row: any, index: any) => {
                          let uniqueIdentifierValue = uniqueIdentifier(
                            row,
                            index
                          );
                          const isItemSelected = this.isSelected(
                            uniqueIdentifierValue
                          );
                          if (row) {
                            let columnData = createData(row, accessRules);
                            return (
                              <TableRow
                                hover
                                role="checkbox"
                                tabIndex={-1}
                                key={index.toString()}
                              >
                                <HasPermission
                                  role={user.role}
                                  accessRules={accessRules}
                                  perform={
                                    deleteAllAction ? deleteAllAction : ""
                                  }
                                  yes={() => (
                                    <TableCell padding="checkbox">
                                      <Checkbox
                                        checked={isItemSelected}
                                        onChange={(event: any) => {
                                          this.handleCheckBoxChange(
                                            event,
                                            uniqueIdentifierValue
                                          );
                                        }}
                                        inputProps={{ "aria-labelledby": "" }}
                                      />
                                    </TableCell>
                                  )}
                                />
                                {columns.map((column: any) => {
                                  const value = this.getObjectFromKey(
                                    columnData,
                                    column.id
                                  );
                                  if (
                                    column.id === "assign" ||
                                    column.id === "sigendBy" ||
                                    column.id === "contacts"
                                  ) {
                                    return (
                                      <TableCell
                                        size="small"
                                        key={column.id}
                                        align={"center"}
                                      >
                                        <IconButton
                                          aria-label="delete"
                                          className={classes.margin}
                                          onClick={() => showDialog(row)}
                                        >
                                          {column.id === "assign" && (
                                            <SwapHorizIcon />
                                          )}
                                          {(column.id === "sigendBy" ||
                                            column.id === "contacts") && (
                                            <PeopleIcon />
                                          )}
                                        </IconButton>
                                      </TableCell>
                                    );
                                  } else if (column.id === "labels") {
                                    return (
                                      <TableCell
                                        size="small"
                                        key={column.id}
                                        align={"center"}
                                        style={{
                                          width: 30,
                                        }}
                                      >
                                        <div
                                          style={{
                                            width: "100%",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                          }}
                                        >
                                          {row.workflows &&
                                          row.workflows.length > 0 ? (
                                            <Avatar
                                              className={classes["small"]}
                                              style={{
                                                backgroundColor: "orange",
                                              }}
                                            >
                                              <Typography
                                                style={{ fontSize: 15 }}
                                              >
                                                {columnData[column.id]}
                                              </Typography>
                                            </Avatar>
                                          ) : (
                                            <Avatar
                                              className={classes["small"]}
                                              style={{
                                                backgroundColor: "transparent",
                                              }}
                                            >
                                              <Typography
                                                style={{ fontSize: 15 }}
                                              >
                                                {""}
                                              </Typography>
                                            </Avatar>
                                          )}
                                        </div>
                                      </TableCell>
                                    );
                                  } else {
                                    if (column.id === "actions" && actions) {
                                      return (
                                        <TableCell
                                          size="small"
                                          key={column.id}
                                          align={"center"}
                                        >
                                          {actions &&
                                            actions.map(
                                              (
                                                actionItem: any,
                                                mIndex: any
                                              ) => {
                                                if (actionItem.visible) {
                                                  return (
                                                    <IconButton
                                                      key={mIndex.toString()}
                                                      size="small"
                                                      aria-label="delete"
                                                      disabled={
                                                        actionItem.disabled
                                                      }
                                                      className={classes.margin}
                                                      onClick={() =>
                                                        actionItem.action(
                                                          row,
                                                          actionItem.name
                                                        )
                                                      }
                                                    >
                                                      {actionItem.icon}
                                                    </IconButton>
                                                  );
                                                } else {
                                                  return (
                                                    <IconButton
                                                      key={mIndex.toString()}
                                                      size="small"
                                                      aria-label="delete"
                                                      style={{
                                                        color: "transparent",
                                                      }}
                                                      disabled={true}
                                                      className={classes.margin}
                                                    >
                                                      {actionItem.icon}
                                                    </IconButton>
                                                  );
                                                }
                                              }
                                            )}
                                        </TableCell>
                                      );
                                    } else {
                                      return (
                                        <TableCell
                                          size="small"
                                          key={column.id}
                                          align={
                                            column.id === "licenseNumbers" ||
                                            "authorizeEquipments" ||
                                            "actionedInspection"
                                              ? "left"
                                              : "center"
                                          }
                                        >
                                          {column.format &&
                                          typeof value === "number"
                                            ? column.format(value)
                                            : this.renderValue(value, row)}
                                        </TableCell>
                                      );
                                    }
                                  }
                                })}
                              </TableRow>
                            );
                          }
                          return null;
                        })}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25, 100, 200]}
                  component="div"
                  count={data.length}
                  rowsPerPage={this.state.rowsPerPage}
                  page={this.state.page}
                  onPageChange={this.handleChangePage}
                  onRowsPerPageChange={this.handleChangeRowsPerPage}
                />
              </Paper>
            </React.Fragment>
          );
        }}
      </AuthConsumer>
    );
  }
}
export default withStyles(styles)(TableComponent);
